module.exports = __webpack_public_path__ + "img/Frame-57.dd3ed522.svg";